/**
 * Alert methods
 */
const alertElementId = 'alertModalId';
const alertTimeout = 2500;
const Alert = {
  getSpanElement(alertElement) {
    const alertChildNodes = alertElement.getElementsByTagName('span');
    return alertChildNodes[0];
  },
  show(alertElement, content, cb) {
      alertElement.style.display = 'block';
      const alertSpanElement = this.getSpanElement(alertElement);
      alertSpanElement.innerHTML = content;
      setTimeout(() => {
        alertElement.style.display = 'none';
        if (cb && typeof cb==='function') {
          cb();
        }
      }, alertTimeout);
  },
  success(content, cb) {
    const alertElement = document.getElementById(alertElementId);
    this.show(alertElement, content, cb);
  },
  error(content) {
    const alertElement = document.getElementById(alertElementId);
    const alertSpanElement = this.getSpanElement(alertElement);
    alertSpanElement.style.color = 'red';
    this.show(alertElement, content);
  }
};

export default Alert;


// WEBPACK FOOTER //
// ./utils/Alert/index.js